<template>
  <TabPanel value="organize">
    <FeatureCard
      span="2"
      title="Organize your bio"
      bg-color="secondary"
      color="secondary"
    >
      <VText gutter-bottom
        >Use our many tools to create a bio link that is organized and optimized
        for your audience.
      </VText>

      <FeatureCardList component="ol">
        <li>Links</li>
        <li>Titles</li>
        <li>Dividers</li>
        <li>Social accounts</li>
        <li>Groups <Badge content="Pro" /></li>
      </FeatureCardList>

      <video
        slot="img"
        src="~/assets/videos/home/organize.mp4"
        loading="lazy"
        type="video/mp4"
        muted
        loop
        playsinline
        style="aspect-ratio: 16 / 9"
      />
    </FeatureCard>
  </TabPanel>
</template>

<script>
import { VText, TabPanel, Badge } from '@campsite-bio/component-lib';

import FeatureCard from '@/components/features/feature-card';
import FeatureCardList from '@/components/features/feature-card-list';

export default {
  components: {
    VText,
    TabPanel,
    Badge,
    FeatureCard,
    FeatureCardList,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
